import { observer } from "mobx-react-lite";
import { PropsWithChildren } from "react";
import { createAppTheme } from "theme";

import { ThemeProvider } from "@mui/material";

export const AppThemeWrapper = observer(({ children }: PropsWithChildren) => {
  return <ThemeProvider theme={createAppTheme()}>{children}</ThemeProvider>;
});
